module.exports = __webpack_public_path__ + "static/media/Annotate_Icon.d17358a6.svg";